<template>
  <div class="flex flex-col">
    <div
      class="flex flex-row gap-2 justify-evenly sm:justify-center px-1 py-[7px] bg-gray-200 rounded-t-xl border border-gray-200"
    >
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="py-[7px] px-3 rounded-[6px] flex flex-row gap-2 items-center cursor-pointer hover:opacity-80"
        :class="{
          'bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.06),0px_1px_3px_0px_rgba(16,24,40,0.10)]':
            selectedTab === tab.key,
          '!cursor-not-allowed': tab.disabled,
        }"
        @click="handleSelectTab(tab)"
      >
        <p
          class="text-sm font-semibold"
          :class="selectedTab === tab.key ? 'text-gray-700' : 'text-gray-500'"
        >
          {{ tab.label }}
        </p>
        <div
          class="grid place-items-center aspect-square rounded-full bg-gray-100 text-gray-700 text-xs w-[22px] font-medium"
        >
          {{ tab.count ?? 0 }}
        </div>
      </div>
    </div>
    <div class="grow basis-0 sm:basis-auto overflow-auto relative sm:h-[350px]">
      <template v-for="tab in tabs">
        <div :key="tab.key + '_tab_content'" v-if="tab.key === selectedTab">
          <div v-if="!!tab.component">
            <MessengerEmptyScreen
              v-if="tab.count === 0 && tab.emptyTitle"
              :title="tab.emptyTitle"
              :description="tab.emptyDescription"
              :image="tab.emptyImage"
            />
            <component
              v-else
              :is="tab.component"
              v-bind="tab.componentAttributes"
            />
          </div>
          <!-- This value is only for debugging. It should never be shown in a correctly configured setup -->
          <p v-else>
            There's an issue with the configuration of this tab. It has no
            component attached to it
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MessengerEmptyScreen from "@/Tailwind/Components/Messenger/MessengerEmptyScreen.vue";

const props = defineProps({
  tabs: Array,
  initialIndex: Number,
});

const selectedTab = ref(props.tabs[props.initialIndex ?? 0].key);

function handleSelectTab(tab) {
  if (tab.disabled) {
    return;
  }
  selectedTab.value = tab.key;
}
</script>
